import { Button, Card, Input, Skeleton } from "antd";
import React, { useRef, useState } from "react";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";

function VideoRecordings() {
    console.log("VideoRecordings component rendered");
    const [tableData, setTableData] = useState([]);
    const kioskIdRef = useRef(null);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [APILoadingState, setAPILoadingState] = useState(false);
    const [loaderDownload, setLoaderDownload] = useState({
        key: null,
        loading: false,
    });

    const findRedordings = async () => {
        // Logic to find and set video recordings based on search input
        setAPILoadingState(true);
        if (!kioskIdRef.current.input.value) {
            setTableData([]);
            console.log("Kiosk ID is empty. Please enter a valid Kiosk ID.");
            return;
        }
        await HTTP("/staff/getKioskVideoRecordings", {
            kiosk_id: kioskIdRef.current.input.value,
            staff_id,
        }).then((res) => {
            console.log("51616", res.data);
            if (res.success) {
                setTableData(res.data);
                setAPILoadingState(false);
            } else setTableData([]);
        });
    };

    const downalodVideo = async (url, key) => {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = key;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoaderDownload({ key: null, loading: false });
        // Clean up the blob URL
        window.URL.revokeObjectURL(blobUrl);
    };

    return (
        <Card className="dashboard-container">
            <div
                className="flex  border-radious-10"
                style={{ justifyContent: "space-between" }}
            >
                <Input
                    placeholder="Search by Kiosk ID"
                    ref={kioskIdRef}
                    allowClear
                />
                <Button type="primary" onClick={findRedordings}>
                    Search
                </Button>
            </div>
            <div style={{ marginTop: "20px" }}>
                {APILoadingState == true ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : tableData.length > 0 ? (
                    <CustomTable
                        dataSource={tableData}
                        columns={[
                            {
                                title: "key",
                                dataIndex: "key",
                                key: "key",
                                render: (text) => (
                                    <span>
                                        {text.replace(
                                            `${kioskIdRef.current.input.value
                                                .toString()
                                                .toLowerCase()}/`,
                                            "",
                                        )}
                                    </span>
                                ),
                            },
                            {
                                title: "Recording Time",
                                dataIndex: "lastModified",
                                key: "lastModified",
                                render: (text) =>
                                    new Date(text).toLocaleString(),
                            },
                            {
                                title: "Recording URL",
                                dataIndex: "url",
                                key: "url",
                                render: (text, record) => (
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            setLoaderDownload({
                                                key: record.key,
                                                loading: true,
                                            });
                                            downalodVideo(text, record.key);
                                        }}
                                    >
                                        {loaderDownload.key == record.key &&
                                        loaderDownload.loading == true
                                            ? "⟳ Downloading..."
                                            : "Download"}
                                    </Button>
                                ),
                            },
                        ]}
                    />
                ) : (
                    <p>No video recordings found.</p>
                )}
            </div>
        </Card>
    );
}

export { VideoRecordings };
